var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyWishlist = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 240,
  height: 160
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF6EC",
  d: "M0 0h240v160H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#1C0A00",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FDF6EC",
  d: "M30 56h180v12H30zM34 68h172v34H34zM30 102h180v12H30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 118h192"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#1C0A00",
  strokeWidth: 1.5,
  d: "M38 75h164M40 82h160M38 89h164M40 96h160"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#8B0000",
  stroke: "#1C0A00",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M152 112.2c-3.2-2.8-26-11.6-26-28.6 0-8.8 7-15.6 15.4-15.6 4.8 0 9 2.4 10.6 5.8 1.6-3.4 5.8-5.8 10.6-5.8 8.4 0 15.4 6.8 15.4 15.6 0 17-22.8 25.8-26 28.6Z"
})));
export { SvgEmptyWishlist as ReactComponent };
export default __webpack_public_path__ + "a3507d8eaa0b6bc49c6a82091f30678d.svg";